import store from '@/store'
export default [
  {
    path: '/buildings',
    name: 'building',
    meta: { requiresAuth: true },
    component: () => import('@/pages/building/index-v2.vue')
  },
  {
    path: '/buildings/:id',
    name: 'building-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/building/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await store.dispatch('building/find', to.params.id)
      let { ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
